import React from 'react'
import PropTypes from 'prop-types'
import InlineSVG from 'svg-inline-react'

import iconSpinnerLight from '!raw-loader!shared/assets/icons/loader.svg'
import iconSpinnerDark from '!raw-loader!shared/assets/icons/loader-dark.svg'

import styles from './Spinner.module.scss'

const Spinner = ({
  visible,
  type
}) => {
  if(!visible) return null

  return (
    <InlineSVG
      className={styles.spinner}
      src={type === 'dark' ? iconSpinnerDark : iconSpinnerLight}
    />
  )
}

Spinner.propTypes = {
  visible: PropTypes.bool,
  type: PropTypes.oneOf([ 'light', 'dark' ])
}

Spinner.defaultProps = {
  visible: false,
  type: 'light'
}

export default Spinner
